export default __webpack_public_path__ + "static/media/202.a7a0b2cc.png";